module.exports = __webpack_public_path__ + "img/physiology.dca4e9f4.png";